import { ASSET_PATHS } from '../../utils/assetPath';

import './RemoveIcon.css';

interface RemoveIconProps {
  /**
   * Additional class name
   */
  className?: string;
  /**
   * Size of the icon in pixels (default: 20)
   */
  size?: number;
  /**
   * Aria label for accessibility
   */
  ariaLabel?: string;
}

/**
 * RemoveIcon component
 *
 * Displays an X/close icon using the SVG from the public folder.
 * Used primarily for remove/close actions throughout the application.
 *
 * @example
 * <RemoveIcon />
 * <RemoveIcon size={24} ariaLabel="Remove item" />
 */
function RemoveIcon({ className = '', size = 20, ariaLabel = 'Remove' }: RemoveIconProps) {
  return (
    <img
      alt=''
      aria-label={ariaLabel}
      className={`remove-icon ${className}`}
      height={size}
      src={ASSET_PATHS.X_ICON}
      width={size}
    />
  );
}

export default RemoveIcon;
